import React from 'react'

import { IconProps } from './types'

const SortAscending: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    data-testid="ascending"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill={color}
    stroke={color}
    {...rest}
  >
    <path d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z" />
  </svg>
)
SortAscending.defaultProps = {
  size: 20,
  color: 'currentColor',
}

export default SortAscending
